/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Actor } from './Actor';
/**
 * Actor that calls a function that change the attributes of an Object3D or shader uniforms
 */
export class FunctionalActor extends Actor {
    /**
     * constructor
     * @param func function that is called on update
     */
    constructor(func) {
        super();
        this._function = func;
    }
    /**
     * see base class
     */
    update() {
        this._function();
    }
    /**
     * see base class
     */
    start() {
        // nothing to do
    }
    /**
     * see base class
     */
    stop() {
        // nothing to do
    }
}
//# sourceMappingURL=FunctionalActor.js.map